import { usePremiumInfoUrl } from '@src/utils/premiumReturn';
import { Fragment } from 'react';
import { Link } from '@src/components';
import { Prose } from '@src/components/Prose/Prose';
import agreement from './termsCom.json';

function TermsText({ text }: { text: string }) {
  const premiumInfoHref = usePremiumInfoUrl();
  return text
    .split(
      /(\*\*[^*]+\*\*|https:\/\/santa-secret\.com(?:\/policy)?|postman@santa-secret\.com|Premium purchase page)/g,
    )
    .map((part, index) => {
      if (part.startsWith('**')) return <strong key={index}>{part.slice(2, -2)}</strong>;
      if (part === 'Premium purchase page')
        return (
          <Link key={index} href={premiumInfoHref} variant="inline">
            {part}
          </Link>
        );
      if (part.startsWith('https://') || part === 'postman@santa-secret.com') {
        return (
          <Link key={index} href={part.includes('@') ? `mailto:${part}` : part} variant="inline">
            {part}
          </Link>
        );
      }
      return <Fragment key={index}>{part}</Fragment>;
    });
}

export function TermsCom() {
  return (
    <Prose>
      <h1>{agreement.title}</h1>
      <span className="prose__meta">{agreement.meta}</span>
      {agreement.sections.map((section, index) => (
        <section key={section.title} aria-labelledby={`terms-section-${index + 1}`}>
          <h2 id={`terms-section-${index + 1}`}>{section.title}</h2>
          {section.blocks.map((block, blockIndex) =>
            block.type === 'list' ? (
              <ul key={blockIndex}>
                {block.items?.map((item) => (
                  <li key={item}>
                    <TermsText text={item} />
                  </li>
                ))}
              </ul>
            ) : (
              <p key={blockIndex}>
                <TermsText text={block.text ?? ''} />
              </p>
            ),
          )}
        </section>
      ))}
    </Prose>
  );
}
